import { ENDPOINTS_LOANS } from 'common/endpoints/loans.endpoints';

export default class MyLoansService {
  constructor($http, LoansStatesService) {
    'ngInject';
    this.http = $http;
    this.loansStatesService = LoansStatesService;
    this._myLoansCache = new Map();
  }

  getMyLoans(employeeId) {
    if (this._myLoansCache.has(employeeId)) {
      return this._myLoansCache.get(employeeId);
    }

    const loans = this.http
      .get(ENDPOINTS_LOANS.get.myLoans(employeeId))
      .then((response) => {
        return response.data.employeeLoans.map(this.loansStatesService.mapStatusCode);
      })
      .catch((err) => {
        this._myLoansCache.delete(employeeId);
        throw err;
      });

    this._myLoansCache.set(employeeId, loans);
    return loans;
  }

  sendRequestNovation(employeeId, loan) {
    const data = {
      requestNovation: loan.identifying,
    };
    return this.http.post(ENDPOINTS_LOANS.post.requestNovation(employeeId), data);
  }
}



// WEBPACK FOOTER //
// ./client/app/loans.module/features/myLoans/myLoans.service.js